import React from "react";
import Skeleton from "react-loading-skeleton";

const OurTeamSkeleton = () => {
    return (
        <div className="col-md-12 as-col-table-container">
            <table className="table table-striped">
                <thead>
                    <tr>
                        {/* <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">N°</th> */}
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Pic</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Fullname</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Title</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Facebook</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Twitter</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Instagram</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default OurTeamSkeleton;
